export const TEXT_SET_LIKE_REQUEST = 'TEXT_SET_LIKE_REQUEST';
export const TEXT_SET_LIKE_REQUEST_SUCCESS = 'TEXT_SET_LIKE_REQUEST_SUCCESS';
export const TEXT_SET_LIKE_REQUEST_FAILURE = 'TEXT_SET_LIKE_REQUEST_FAILURE';

export const TEXT_SET_LIKE_CREATE_REQUEST = 'TEXT_SET_LIKE_CREATE_REQUEST';
export const TEXT_SET_LIKE_CREATE_REQUEST_SUCCESS = 'TEXT_SET_LIKE_CREATE_REQUEST_SUCCESS';

export const TEXT_SET_LIKE_DELETE_REQUEST = 'TEXT_SET_LIKE_DELETE_REQUEST';
export const TEXT_SET_LIKE_DELETE_REQUEST_SUCCESS = 'TEXT_SET_LIKE_DELETE_REQUEST_SUCCESS';
